<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space"><span class="text">{{ msgAlerta }}</span></div>

    <div>
        <div class="form-edit-page row row-space">
            <div class="form-item">
                <label class="label-caption" for="nmPesquisa">Pesquisar</label>
                <input type="text" v-model="nmPesquisa" id="nmPesquisa" maxlength="50" v-uppercase />
            </div>
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>

        <table>
            <thead><tr>
                <th class="col-width-char10">Código</th>
                <th>Produto</th>
                <th class="col-width-char50">Categoria</th>
                <th class="col-width-char10">Unidade</th>
                <th class="col-width-char10">Situação</th>
            </tr></thead>
            
            <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'mark-row': obj.atribuido=='S'}">
                <td class="col-width-char10 right">{{ obj.id }}</td>
                <td>{{ obj.nmproduto }}</td>
                <td class="col-width-char50">{{ obj.nmcategoria }}</td>
                <td class="col-width-char10">{{ obj.unidade }}</td>
                <td class="col-width-char10 center label-link" @click="trocarOpcao(index)">{{ obj.atribuido=='N' ? 'INATIVO' : 'ATIVO' }}</td>
            </tr></tbody>
        </table>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { genericPost } from '@/funcoes/api'; 
import { globalStore } from '@/globals';

const emit = defineEmits(['close']);
const isLoading = ref(false);
const lsDados = ref([]);
const msgAlerta = ref(null);
const nmPesquisa = ref(null);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

function closeForm() {
    emit('close');
}

const lerDados = async() => {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await genericPost('/listas/estabelecimento/prodmapa/config', {
            idep: globalStore.idep,
            idestabelecimento: globalStore.idestabelecimento,
            nmpesquisar: nmPesquisa.value,
            strparam1: globalStore.atividade.tpproduto_mapa});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}

async function trocarOpcao(idx) {
    try{
        msgAlerta.value=null;
        if (lsDados.value[idx].atribuido=='N'){
            const at = await genericPost('/cad/exec_requisicao', {
                nmrequisicao: 'estabelecimentos_prmapa_habilitar',
                idestabelecimento: globalStore.idestabelecimento,
                idreferencia: lsDados.value[idx].id});
            if (at.bolok==1){
                lsDados.value[idx].atribuido='S';
            }else{msgAlerta.value=`ATENÇÃO: ${at.erro}`}
        }else{
            const at = await genericPost('/cad/exec_requisicao', {
                nmrequisicao: 'estabelecimentos_prmapa_desabilitar',
                idestabelecimento: globalStore.idestabelecimento,
                idreferencia: lsDados.value[idx].id});
            if (at.bolok==1){
                lsDados.value[idx].atribuido='N';
            }else{msgAlerta.value=`ATENÇÃO: ${at.erro}`}
        }
    } catch(e){msgAlerta.value = `ATENÇÃO: ${e}`}
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados)
</script>
